import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { unit } from '@hcr/ui'
import { isNotNull, isNotUndefined } from '@hcr/utils'

import { COLORS, ICONS } from '../../../../../../../libs/ui/src/lib/constants'
import { useHoliday } from '../../../../contexts'
import { useAccommodationDetailsQuery, useDestinationDetailsQuery, useIdToken } from '../../../../hooks'
import { Path } from '../../../../models'
import { DateFormat } from '../../../../models/i18n'
import { dateFormatter } from '../../../../utils/dates'
import { LayoutBookingOverviewHero } from '../common/layout-booking-overview'

import { BookingOverviewHomeLoading } from './BookingOverviewHomeLoading'

export const BookingOverviewHome: FC = () => {
  const { t } = useTranslation()
  const idToken = useIdToken()
  const holiday = useHoliday()

  const accommodation = useAccommodationDetailsQuery(
    { idToken: String(idToken), accommodationId: Number(holiday.data.accommodationId) },
    { enabled: isNotNull(holiday.data.accommodationId) && isNotNull(idToken) }
  )

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(holiday.data.destinationId) },
    { enabled: isNotNull(holiday.data.destinationId) }
  )

  if (holiday.isSuccess && accommodation.isSuccess && isNotUndefined(destinationDetails.data)) {
    return (
      <LayoutBookingOverviewHero>
        <Stack direction='row' gap={unit(3)}>
          <Stack height={unit(6.5)} alignItems={'center'} flexDirection='row'>
            <FontAwesomeIcon fontSize={unit(5)} icon={ICONS.falCalendarHeart} color={COLORS.burgundi[500]} />
          </Stack>
          <Stack direction='column' paddingRight={unit(3)}>
            <Typography variant='titleS'>{t('booking-overview.your-vacation-is-approaching')}</Typography>
            <Stack direction='column' paddingRight={unit(10.5)}>
              <Typography variant='bodyM'>
                {destinationDetails.data.name}{' '}
                {dateFormatter.format(DateFormat.DayOfTheWeekShort, accommodation.data.start_date)}{' '}
                {dateFormatter.format(DateFormat.Basic, accommodation.data.start_date)} -{' '}
                {dateFormatter.format(DateFormat.DayOfTheWeekShort, accommodation.data.end_date)}{' '}
                {dateFormatter.format(DateFormat.Basic, accommodation.data.end_date)}
              </Typography>
              <Typography
                component='a'
                rel={'rel'}
                href={Path.Booking}
                role='link'
                variant='textLinkM'
                color={COLORS.burgundi[500]}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: unit(1.5),
                }}
              >
                {t('booking-overview.view-reservation')}
                <FontAwesomeIcon icon={ICONS.farArrowRight} />
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </LayoutBookingOverviewHero>
    )
  }

  return <BookingOverviewHomeLoading />
}
